/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { createInterviewBookingTokensInputMeetingLocationTypeSchema } from './CreateInterviewBookingTokensInputMeetingLocationTypeSchema'

export const createInterviewBookingTokensInputSchema = z.object({
	campaignId: z.string().uuid(),
	candidateIds: z.array(z.string()),
	meetingLocationType: createInterviewBookingTokensInputMeetingLocationTypeSchema.nullable().optional(),
	meetingLocationDetails: z.string().nullable().optional(),
	acknowledgedCandidateIds: z.array(z.string()).optional().default([]),
})

export type CreateInterviewBookingTokensInputSchema = z.infer<typeof createInterviewBookingTokensInputSchema>
